<template>
  <span class="hand">
    <span @click="isOpen = true"><slot /></span>
    <hi-dialog
      v-if="lead"
      v-model="isOpen"
      :title="lead.name"
      submit-txt="Goto Lead Details"
      @submit="goToLead"
    >
      <hi-row>{{ lead.name }} {{ lead.surname }}</hi-row>
      <hi-row>{{ lead.email }}</hi-row>
      <hi-row>{{ lead.mobile }}</hi-row>
      <hi-row v-if="lead.phone">{{ lead.phone }}</hi-row>
      <hi-row>
        Projects:
        <span v-for="project in lead.projects" :key="project">
          {{ project }}
        </span>
      </hi-row>
      <hi-row> Source: {{ lead.source || "unknown" }} </hi-row>
      <hi-row> Created: {{ lead.dateCreated | timestamp }}</hi-row>
    </hi-dialog>
  </span>
</template>

<script>
import HiDialog from "@/components/HiDialog";
import { db } from "@/db";
import HiRow from "@/components/scaffold/HiRow";

export default {
  name: "DiDetails",
  components: { HiRow, HiDialog },
  props: {
    leadId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
      lead: null
    };
  },
  firestore() {
    return {
      lead: db.collection("leads").doc(this.leadId)
    };
  },
  methods: {
    clicked() {
      console.log(this.leadId);
      this.isOpen = true;
    },
    goToLead() {
      this.$router.push("/leads/" + this.leadId);
    }
  }
};
</script>

<style scoped></style>
